import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompSliderWrapperCore } from '../core/forms/slider/wrapper'
import { CompSlider } from './CompSlider'

/**
 * CompSliderWrapper
 *
 */
function CompSliderWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompSliderWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompSlider {...props} />}
    </CompSliderWrapperCore>
  )
}


export default CompSliderWrapper